<!--
	Copyright (c) 2024, Signaloid.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
-->

<template>
	<vue3-snackbar :limit="2" top :duration="5000"></vue3-snackbar>
	<v-app>
		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useSnackbar, Vue3Snackbar } from 'vue3-snackbar'
import { useSnackbarStore } from '@/stores/snackbar.store'

type ComponentData = {
	appEventBusSub: undefined | Function
}

export default defineComponent({
	name: 'App',
	data: (): ComponentData => ({
		appEventBusSub: undefined
	}),
	components: {
		Vue3Snackbar
	},
	setup() {
		const snackbar = useSnackbar()
		const snackBarStore = useSnackbarStore()

		watch(snackBarStore.getMessages, (messages) => {
			const message = messages[messages.length - 1]
			snackbar.add({
				type: message.type,
				text: message.text
			})
		})
	},
	methods: {}
})
</script>
<style>
.vue3-snackbar-message {
	border-radius: 10px !important;
	&.success {
		background-color: #eeffe5 !important;
		color: black !important;
		border: 1px solid #89ff4c !important;
	}
	&.error {
		background-color: #ffe5e5 !important;
		color: red !important;
		border: 1px solid red !important;
	}
}
</style>
